// Hexes (docs/04 §13, docs/05 §6): fine-print curses that last HEX_DURATION spins, up to 3 at once.
import { B } from './balance';
import { defineHex, type HexDef } from './defs';

export const HEX_LIST: HexDef[] = [
  defineHex({
    id: 'h_lock',
    targetsReel: true,
    requires: (m) => m.features.has('hold') || m.features.has('nudge'),
    mods: (m, h) => void (h.reel !== undefined && m.lockedReels.add(h.reel)),
  }),
  defineHex({
    id: 'h_invert',
    requires: (m) => m.features.has('nudge'),
    mods: (m) => {
      m.invertNudge = true;
      m.hidePreview = true;
    },
  }),
  defineHex({ id: 'h_badluck', mods: (m) => void (m.luck += B.HEX_BAD_LUCK) }),
  defineHex({ id: 'h_blind', mods: (m) => void (m.peekRows = 0) }),
  defineHex({ id: 'h_tax', mods: (m) => void m.xMult.push({ source: 'h_tax', x: B.HEX_TAX }) }),
  defineHex({
    id: 'h_rot',
    requires: (m) => m.symbolGates.has('rot'),
    mods: (m) => void (m.ageExtraByTag.fruit = (m.ageExtraByTag.fruit ?? 0) + B.HEX_ROT_AGE),
  }),
  defineHex({ id: 'h_pang', requires: (m) => m.features.has('face'), mods: (m) => void (m.hungerPerSpin += B.HEX_PANG) }),
  defineHex({ id: 'h_sticky', mods: (m) => void (m.offPatternOff = true) }),
];
